import { IUseGraphqlQueryOptions } from '@proscom/prostore-apollo-react';
import { skipIfNull } from '@proscom/prostore';
import { useAuthGraphqlQuery } from '../../../common/hooks/utils/useAuthGraphqlQuery';
import { ExternalPollType } from '../../types';
import { QUERY_GET_EXTERNAL_POLL } from '../../queries/polls';

export interface UseExternalPollVars {
  id: string;
}

const queryOptions: IUseGraphqlQueryOptions<
  UseExternalPollVars | null,
  ExternalPollType | null
> = {
  query: QUERY_GET_EXTERNAL_POLL,
  mapData: (result) => result.externalPoll,
  skipQuery: skipIfNull(null)
};

export function useExternalPoll(id?: string) {
  return useAuthGraphqlQuery({
    queryOptions,
    variables: id ? { id } : null
  });
}
